// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Feier-Trigger. Die Fabelwesen-Anzeige (Celebration.tsx) kommt in der Politur-Phase;
// bis dahin hört nur der Toast auf große Momente.
export type CelebrateEvent =
  | { kind: "save" }
  | { kind: "day-complete"; dayCode: string }
  | { kind: "milestone"; text: string }
  | { kind: "record"; text: string }
  | { kind: "workout-complete"; summary: string }

export function celebrate(event: CelebrateEvent): void {
  window.dispatchEvent(new CustomEvent("fithub:celebrate", { detail: event }))
}

// ── Wie laut wird gefeiert? (Optionen → Aussehen, Thors Feedback Runde 11) ──

export type FeierStufe = "dezent" | "normal" | "praesent"

const STUFE_KEY = "fithub:feier"

export const FEIER_STUFEN: Array<{ id: FeierStufe; name: string; text: string }> = [
  { id: "dezent", name: "Dezent", text: "Kleines Wesen, kein Konfetti." },
  { id: "normal", name: "Normal", text: "Wesen und Konfetti bei den großen Momenten." },
  { id: "praesent", name: "Präsent", text: "Riesige Wesen, Konfetti auch beim Speichern." },
]

export function feierStufe(): FeierStufe {
  try {
    const v = localStorage.getItem(STUFE_KEY)
    return v === "dezent" || v === "praesent" ? v : "normal"
  } catch { return "normal" }
}

export function setFeierStufe(stufe: FeierStufe): void {
  try { localStorage.setItem(STUFE_KEY, stufe) } catch { /* nicht speicherbar — egal */ }
}
